<div style="overflow: hidden">
  <div class="row ">
    <div class="col-5 pr-0">
      <div #focus tabindex="-1" class="card"
           style="height: calc(100vh - 95px); overflow-y: scroll; border-radius: unset !important; padding-bottom: 50px;">
        <app-panel-setup-sign-flow-receive (navigate)="onBackClick()"></app-panel-setup-sign-flow-receive>
      </div>
    </div>
    <div class="col-7 pl-0">
      <div class="bg-white mat-elevation-z0 py-2 px-3 border-bottom">
        <div class="row">
          <div class="col-5 text-left pt-2 fix-width"
               [matTooltip]="documentParentName ? document.name + ' - ' + documentParentName : document.name">
            <strong> {{document.name}} </strong>
            <strong *ngIf="document.parentId"> - {{documentParentName}} </strong>
          </div>
          <div class="col-2 text-center">
            <ng-container *ngIf="pdfSrc">
                <button matTooltip="{{'enterprise_contract.buttons.zoom_in' | translate}}" mat-icon-button
                        color="primary" (click)="zoomIn()" [disabled]="zoomLevel > 4.8">
                  <mat-icon>zoom_in</mat-icon>
                </button>
                <button matTooltip="{{'enterprise_contract.buttons.zoom_out' | translate}}" mat-icon-button
                        color="primary" (click)="zoomOut()" [disabled]="zoomLevel <= .4">
                  <mat-icon>zoom_out</mat-icon>
                </button>
              </ng-container>
          </div>
          <div class="col-5 text-right">
            <button mat-stroked-button color="primary" class="mr-3" (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'enterprise_contract.buttons.download' | translate}}
            </button>
          </div>
        </div>
      </div>
      <div class="document" #focus tabindex="0" style="height: calc(100vh - 201px);">
        <div>
          <ng-container *ngIf="pdfSrc != ''">
            <ngx-extended-pdf-viewer
              class="pdf-viewer"
              [src]="pdfSrc"
              [zoom]="zoomLevel">
            </ngx-extended-pdf-viewer>
          </ng-container>
          <ng-template #notUpload>
            <div *ngIf="pdfSrc" class="doc-wrapper view-document" [innerHTML]="pdfSrc | noSanitize"></div>
          </ng-template>
        </div>
      </div>
      <hr style="margin: 0;">
      <div class="bg-white text-center mat-elevation-z0 py-2" #navigation id="navigation">
        <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="onBackClick()">
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{'form.back' | translate}}
        </button>
        <button mat-raised-button color="primary" lass="mr-3" (click)="saveSignFlow()">
          <mat-icon class="mr-0">send</mat-icon>
          Lưu luồng ký nội bộ
        </button>
      </div>
    </div>
  </div>
</div>
